import {
  INICIA_ALUNO,
  NOVO_ALUNO,
  BUSCA_ALUNO_EDICAO,
  CANCELA_EDICAO,
  INICIO_ALUNO_SUCESSO,
  SALVA_ALUNO_SUCESSO,
  REMOVE_ALUNO_SUCESSO,
  BUSCA_ALUNO_EDICAO_SUCESSO,
  INIT_URL,
  HIDE_MESSAGE,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  ON_SHOW_ERROR_MESSAGE,
  SHOW_MESSAGE,
  ALTERACAO_CAMPO,
  ALTERACAO_COMBO,
  ALTERACAO_DATEPICKER,
  ALTERACAO_CHECK,
  APLICA_FILTRO,
  LISTA_ALUNO,
  LISTA_ALUNO_SUCESSO,
  LIMPAR_ALUNO,
  SALVA_ALUNO,
  ATUALIZA_ALUNO,
  LISTA_ESCOLAS_ALUNO_SUCESSO,
  LISTA_CURSOS_POR_ESCOLA_ALUNO_SUCESSO,
  LISTA_SERIES_POR_CURSO_ALUNO_SUCESSO,
  LISTA_TURMAS_POR_SERIE_ALUNO_SUCESSO,
  APLICA_FILTRO_ALUNO
} from "constants/ActionTypes";

const normalizeAlunoListItem = (a) => {
  const id = a.id || a.Id || 0;
  const pessoaNome = a.pessoaNome || a.PessoaNome || a.nome || a.Nome || '';
  const codigoInep = a.codigoInep || a.CodigoInep || '';
  const pessoaCpf = a.pessoaCpf || a.PessoaCpf || a.cpf || a.Cpf || '';
  const pessoaDataNascimento = a.pessoaDataNascimento || a.PessoaDataNascimento || a.dataNascimento || a.DataNascimento || a.dataNascimentoStr || a.DataNascimentoStr || '';
  return { ...a, id, pessoaNome, codigoInep, pessoaCpf, pessoaDataNascimento };
};


const INIT_STATE = {
  // Configuração da Grid
  colunasGrid: [
    { titulo: 'Código INEP', propriedadeApi: 'codigoInep', alinhamento: 'left' },
    { titulo: 'Aluno', propriedadeApi: 'pessoaNome', alinhamento: 'left' },
    { titulo: 'CPF', propriedadeApi: 'pessoaCpf', alinhamento: 'left' },
    { titulo: 'Data Nascimento', propriedadeApi: 'pessoaDataNascimento', alinhamento: 'left' }
  ],

  // Propriedades Globais
  loader: false,
  alertMessage: '',
  showMessageSuccess: false,
  showMessageError: false,
  edicao: false,
  carregandoLista: true,
  listGrid: [],
  listGridComFiltro: [],
  textoFiltro: '',
  alunoCarregado: null,

  // Campos do Formulario (mínimos)
  id: 0,
  codigoInep: '',
  pessoaVinculada: '',
  pessoaNome: '',
  pessoaCpf: '',
  pessoaDataNascimento: '',

  // Filtros
  nomeAlunoFiltro: '',
  idadeFiltro: '',
  escolaFiltro: null,
  cursoFiltro: null,
  serieFiltro: null,
  turmaFiltro: null,

  listaEscolas: [],
  listaCursosPorEscola: [],
  listaSeriesPorCurso: [],
  listaTurmasPorSerie: [],

  // Paginação e Ordenação Servidor
  page: 1,
  perPage: 10,
  orderBy: '',
  orderDirection: 'asc',
  totalRecords: 0
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ALTERACAO_CAMPO: {
      return {
        ...state,
        [action.payload.target.name]: action?.payload?.target?.value,
      }
    }
    case INICIA_ALUNO: {
      return {
        ...state,
        edicao: false,
        loader: true,
        carregandoLista: true,
        textoFiltro: '',
        alunoCarregado: null,
        id: 0,
        codigoInep: '',
        pessoaVinculada: '',
        pessoaNome: '',
        pessoaCpf: '',
        pessoaDataNascimento: '',
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false
      }
    }
    case NOVO_ALUNO: {
      return {
        ...state,
        edicao: true,
        alunoCarregado: null,
        id: 0,
        codigoInep: '',
        pessoaVinculada: '',
        pessoaNome: '',
        pessoaCpf: '',
        pessoaDataNascimento: ''
      }
    }
    case SALVA_ALUNO: {
      return {
        ...state,
        loader: true,
      }
    }
    case ATUALIZA_ALUNO: {
      return {
        ...state,
        loader: true,
      }
    }
    case CANCELA_EDICAO: {
      return {
        ...state,
        edicao: false,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
        loader: false
      }
    }
    case BUSCA_ALUNO_EDICAO: {
      return {
        ...state,
        loader: true,
      }
    }
    case INICIO_ALUNO_SUCESSO: {
      const retorno = action.payload;
      // Algumas APIs retornam a lista sob a chave 'aluno' (singular) e outras sob 'alunos' (plural).
      // Para garantir compatibilidade, aceitamos ambas e também o próprio payload como lista.
      const lista = retorno?.alunos || retorno?.aluno || retorno || [];
      return {
        ...state,
        loader: false,
        carregandoLista: false,
        listGrid: lista,
        listGridComFiltro: lista
      }
    }
    case SALVA_ALUNO_SUCESSO: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload,
        showMessageSuccess: true,
        edicao: false
      }
    }
    case REMOVE_ALUNO_SUCESSO: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload,
        showMessageSuccess: true,
        edicao: false
      }
    }
    case LISTA_ALUNO: {
      const { page, perPage, orderBy, orderDirection } = action.payload || {};
      return {
        ...state,
        loader: true,
        carregandoLista: true,
        page: page !== undefined ? page : state.page,
        perPage: perPage !== undefined ? perPage : state.perPage,
        orderBy: orderBy !== undefined ? orderBy : state.orderBy,
        orderDirection: orderDirection !== undefined ? orderDirection : state.orderDirection
      }
    }
    case APLICA_FILTRO_ALUNO: {
      const texto = action.payload || '';
      return {
        ...state,
        textoFiltro: texto
      }
    }
    case LISTA_ALUNO_SUCESSO: {
      const retorno = action.payload;
      // Normalização idêntica à de matrícula para garantir consistência
      const lista = Array.isArray(retorno) ? retorno : (Array.isArray(retorno?.alunos) ? retorno.alunos : (Array.isArray(retorno?.aluno) ? retorno.aluno : []));
      const totalRecords = retorno?.totalRecords || retorno?.TotalRecords || lista.length;
      const listaNorm = Array.isArray(lista) ? lista.map(normalizeAlunoListItem) : [];
      return {
        ...state,
        loader: false,
        carregandoLista: false,
        listGrid: listaNorm,
        listGridComFiltro: listaNorm,
        totalRecords
      }
    }
    case LIMPAR_ALUNO: {
      return {
        ...state,
        nomeAlunoFiltro: '',
        textoFiltro: '',
        idadeFiltro: '',
        escolaFiltroAluno: null,
        cursoFiltroAluno: null,
        serieFiltroAluno: null,
        turmaFiltroAluno: null
      }
    }
    case LISTA_ESCOLAS_ALUNO_SUCESSO: {
      const escolasRaw = action.payload?.escolas || action.payload || [];
      const listaEscolas = Array.isArray(escolasRaw)
        ? escolasRaw.map(e => ({ id: e.id || e.Id, title: e.nome || e.Nome }))
        : [];
      return { ...state, listaEscolas };
    }
    case LISTA_CURSOS_POR_ESCOLA_ALUNO_SUCESSO: {
      const cursosRaw = action.payload?.cursos || action.payload || [];
      const listaCursosPorEscola = Array.isArray(cursosRaw)
        ? cursosRaw.map(c => {
          const id = c.id || c.Id || c.cursoId || c.CursoId || 0;
          const nome = c.nome || c.cursoNome || c.descricao || c.Descricao || c.titulo || c.Titulo || '';
          const title = String(nome || id || '');
          return { id, title };
        })
        : [];
      return { ...state, listaCursosPorEscola };
    }
    case LISTA_SERIES_POR_CURSO_ALUNO_SUCESSO: {
      const seriesRaw = action.payload?.series || action.payload || [];
      const listaSeriesPorCurso = Array.isArray(seriesRaw)
        ? seriesRaw.map(s => {
          const id = s.id || s.Id || s.serieId || s.SerieId || 0;
          const nome = s.nome || s.serieNome || s.descricao || s.Descricao || '';
          const title = String(nome || id || '');
          return { id, title };
        })
        : [];
      return { ...state, listaSeriesPorCurso };
    }
    case LISTA_TURMAS_POR_SERIE_ALUNO_SUCESSO: {
      const turmasRaw = action.payload?.turmas || action.payload || [];
      const listaTurmasPorSerie = Array.isArray(turmasRaw)
        ? turmasRaw.map(t => {
          const id = t.id || t.Id || t.turmaId || t.TurmaId || 0;
          const nome = t.Nome || t.turmaNome || t.descricao || t.Descricao || t.codigo || t.Codigo || '';
          const title = String(nome || id || '');
          return { id, title };
        })
        : [];
      return { ...state, listaTurmasPorSerie };
    }
    case BUSCA_ALUNO_EDICAO_SUCESSO: {
      var retorno = action.payload;
      // Em alguns cenários o backend retorna o aluno dentro de uma propriedade 'aluno'.
      // Normalizamos aqui para que o formulário receba o objeto do aluno diretamente.
      var base = retorno && retorno.aluno ? retorno.aluno : retorno;
      // Ajuste: garantir que responsaveis unificado esteja disponível para o formulário
      // O container/form mapeia responsaveis -> responsaveis/autorizados locais
      return {
        ...state,
        edicao: true,
        loader: false,
        alunoCarregado: {
          ...base,
          responsaveis: Array.isArray(base.responsaveis) ? base.responsaveis : (Array.isArray(base.RelacionamentosPessoa) ? base.RelacionamentosPessoa : [])
        },
        id: base.id || base.Id || 0,
        codigoInep: base.codigoInep || base.CodigoInep || '',
        pessoaVinculada: base.pessoaVinculada || base.PessoaVinculada || '',
        pessoaNome: base.pessoaNome || base.PessoaNome || '',
        pessoaCpf: base.pessoaCpf || base.PessoaCpf || '',
        pessoaDataNascimento: base.pessoaDataNascimento || base.PessoaDataNascimento || '',
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
      }
    }
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload
      }
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
        loader: false
      }
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false
      }
    }
    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true
      }
    }
    case ON_SHOW_ERROR_MESSAGE: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload,
        showMessageError: true,
        edicao: false
      }
    }
    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessageError: true,
        loader: false
      }
    }
    case ALTERACAO_COMBO: {
      const valorBruto = action.payload.valor;
      const valorNormalizado = (valorBruto && typeof valorBruto === 'object')
        ? (valorBruto.id !== undefined ? valorBruto.id : (valorBruto.value !== undefined ? valorBruto.value : valorBruto))
        : valorBruto;
      const chave = action.payload.nomeCombo;
      return {
        ...state,
        [chave]: valorNormalizado,
      }
    }
    case ALTERACAO_CHECK: {
      var retorno = action.payload;
      return {
        ...state,
        [retorno.name]: retorno.value
      }
    }
    case ALTERACAO_DATEPICKER: {
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      }
    }
    default:
      return state;
  }
}
